import { PageGenericQuotationListComponent } from './pages/page-generic-quotation-list/page-generic-quotation-list.component';
import { PageQuotationRequestDetailsComponent } from './pages/page-quotation-request-details/page-quotation-request-details.component';
import { FeatureGuard } from './../../_guards/feature.guard';
import { VouchersGuard, LoyaltyGuard, QuotationsFeatureGuard, ChatGuard } from './../../_guards/site.guard';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PageLoginComponent } from './pages/page-login/page-login.component';
import { LayoutComponent } from './components/layout/layout.component';
import { PageDashboardComponent } from './pages/page-dashboard/page-dashboard.component';
import { PageOrdersListComponent } from './pages/page-orders-list/page-orders-list.component';
import { PageAddressesListComponent } from './pages/page-addresses-list/page-addresses-list.component';
import { PageProfileComponent } from './pages/page-profile/page-profile.component';
import { PagePasswordComponent } from './pages/page-password/page-password.component';
import { PageEditAddressComponent } from './pages/page-edit-address/page-edit-address.component';
import { PageMessagesComponent } from './pages/page-messages/page-messages.component';
import { PageQuotationsListComponent } from './pages/page-quotations-list/page-quotations-list.component';
import { PageActiveQuotationsListComponent } from './pages/page-active-quotations-list/page-active-quotations-list.component';
import { PageRequestQuotationsListComponent } from './pages/page-request-quotations-list/page-request-quotations-list.component';
import { QuotationGuard } from '@app/_guards/quoutation.guard';
import { PageQuotationDetailsComponent } from './pages/page-quotation-details/page-quotation-details.component';
import { PageLoyaltyComponent } from './pages/page-loyalty/unused-page-loyalty.component';
import { PageVouchersComponent } from './pages/page-vouchers/page-vouchers.component';
import { PageLiveChatComponent } from './pages/page-live-chat/page-live-chat.component';
import { AuthGuard } from '@app/_guards/auth.guard';
import { PageOrderDetailsParentComponent } from './pages/page-order-details/page-order-details.component';
import { PagePropertyListComponent } from './pages/page-property/property-list/page-property-list.component';
import { PropertyDetailsComponent } from './pages/page-property/property-details/property-details.component';
import { PageBookingsComponent } from './pages/page-bookings/page-bookings.component';
import { PageSubscriptionProfileComponent } from './pages/page-subscription-profile/page-subscription-profile.component';
import { PageAiTokensComponent } from './pages/page-ai-tokens/page-ai-tokens.component';
import { CustomerGuard } from '@app/_guards/customer.guard';

const routes: Routes = [
    {
        path: '',
        component: LayoutComponent,
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'dashboard'
            },
            {
                path: 'dashboard',
                component: PageDashboardComponent,
                canActivate:[AuthGuard]
            },
            {
                path: 'profile',
                component: PageProfileComponent
            },
            {
                path: 'subscription',
                component: PageSubscriptionProfileComponent,
                canActivate: [AuthGuard, CustomerGuard]
            },
            {
                path: 'ai-tokens',
                component: PageAiTokensComponent,
                canActivate: [AuthGuard, CustomerGuard]
            },
            {
                path: 'addresses',
                component: PageAddressesListComponent
            },
            // {
            //     path: 'addresses/:addressId',
            //     component: PageEditAddressComponent
            // },
            {
                path: 'orders',
                component: PageOrdersListComponent
            },
            {
                path: 'bookings',
                component: PageBookingsComponent,
            },
            {
                path: 'vouchers',
                canActivate: [FeatureGuard],
                runGuardsAndResolvers: 'always',
                data: {
                    feature : 'vouchers'
                },
                component: PageVouchersComponent
            },
            {
                path: 'loyalty',
                canActivate: [FeatureGuard],
                runGuardsAndResolvers: 'always',
                data: {
                    feature : 'loyalty'
                },
                component: PageLoyaltyComponent
            },
            {
                path: 'quotation-requests',
                canActivate: [FeatureGuard],
                runGuardsAndResolvers: 'always',
                data: {
                    feature : 'quotationRequests'
                },
                component: PageGenericQuotationListComponent
            },
            {
                path: 'quotation-requests/:slug',
                canActivate: [FeatureGuard],
                runGuardsAndResolvers: 'always',
                data: {
                    feature : 'quotationRequests'
                },
                component: PageQuotationRequestDetailsComponent
            },
            {
                path: 'quotations',
                canActivate: [FeatureGuard],
                runGuardsAndResolvers: 'always',
                data: {
                    feature : 'quotations'
                },
                component: PageQuotationsListComponent
            },
            {
                path: 'property',
                // canActivate: [FeatureGuard],
                // runGuardsAndResolvers: 'always',
                data: {
                    feature : 'property'
                },
                component: PagePropertyListComponent
            },
            {
                path: 'property/:id',
                // canActivate: [FeatureGuard],
                // runGuardsAndResolvers: 'always',
                data: {
                    feature : 'property'
                },
                component: PropertyDetailsComponent
            },
            {
                path: 'ownerProperty',
                // canActivate: [FeatureGuard],
                // runGuardsAndResolvers: 'always',
                data: {
                    feature : 'ownerProperty'
                },
                component: PagePropertyListComponent
            },
            {
                path: 'ownerProperty/:id',
                // canActivate: [FeatureGuard],
                // runGuardsAndResolvers: 'always',
                data: {
                    feature : 'ownerProperty'
                },
                component: PropertyDetailsComponent
            },
            {
                path: 'quotations/:slug',
                canActivate: [FeatureGuard],
                runGuardsAndResolvers: 'always',
                data: {
                    feature : 'quotations'
                },
                component: PageQuotationDetailsComponent
            },
            {
                path: 'quotation-drafts',
                canActivate: [QuotationGuard, FeatureGuard],
                runGuardsAndResolvers: 'always',
                data: {
                    feature : 'quotations'
                },
                component: PageRequestQuotationsListComponent
            },
            {
                path: 'active-quotations',
                canActivate: [FeatureGuard],
                runGuardsAndResolvers: 'always',
                data: {
                    feature : 'quotations'
                },
                component: PageActiveQuotationsListComponent
            },
            {
                path: 'active-quotations/:slug',
                canActivate: [FeatureGuard],
                runGuardsAndResolvers: 'always',
                data: {
                    feature : 'quotations'
                },
                component: PageQuotationDetailsComponent
            },
            {
                path: 'orders/:orderId',
                component: PageOrderDetailsParentComponent
            },
            {
                path: 'password',
                component: PagePasswordComponent
            },
            {
                path: 'messages',
                component: PageMessagesComponent
            },
            {
                path: 'live-chat',
                component: PageLiveChatComponent,
                canActivate: [AuthGuard, FeatureGuard],
                runGuardsAndResolvers: 'always',
                data: {
                    feature : 'chat'
                },
            }
        ]
    },
    {
        path: 'login',
        component: PageLoginComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AccountRoutingModule { }
